export default defineNuxtRouteMiddleware(async (to, from) => {
  const { fullPath: fromFullPath } = from
  const { fullPath: toFullPath } = to

  // skip middleware for the same routes
  if (fromFullPath === toFullPath) {
    return
  }

  // skip middleware on server
  if (import.meta.server) {
    return
  }

  const nuxtApp = useNuxtApp()

  // skip middleware on initial client load
  if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) {
    return
  }

  const logger = useLogger('route-track')

  const appStore = useAppStore()

  const {
    isMainMenuOpened,
    isTickerOpened,
    isSearchOpened,
  } = storeToRefs(appStore)

  logger.debug(`Route changed from ${fromFullPath} to ${toFullPath}`)

  isMainMenuOpened.value = false
  isTickerOpened.value = false
  isSearchOpened.value = false
})
